<template>
  <!-- hero - start -->
  <div class="pb-9 mt-40 sm:pb-8 lg:pb-12 animate__backInLeft">
    <div class="max-w-screen-2xl px-4 md:px-8 mx-auto">
      <section
        class="flex flex-col lg:flex-row justify-between gap-6 sm:gap-10 md:gap-16"
      >
        <!-- content - start -->
        <div
          class="xl:w-5/12 flex flex-col justify-center sm:text-center lg:text-left lg:py-12 xl:py-24"
        >
          <h1
            class="text-black-800 text-4xl sm:text-5xl md:text-6xl font-bold mb-8 md:mb-12"
          >
            Refer a client to afrihost
          </h1>

          <p
            class="lg:w-4/5 text-gray-500 xl:text-lg leading-relaxed mb-8 md:mb-12"
          >
            We just can't stop thinking of ways to help where we can refer a
            client to afrihost and we will give you one month free service.
          </p>

          <div
            class="flex flex-col sm:flex-row sm:justify-center lg:justify-start gap-2.5"
          >
            <a
              href="/contact"
              class="transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 duration-300inline-block hover:bg-indigo-600 active:bg-indigo-700 focus-visible:ring ring-indigo-300 text-white text-sm md:text-base font-semibold text-center rounded-3xl outline-none duration-100 px-8 py-3"
              >Learn More</a
            >

            <a
              href="/contact"
              class="transition ease-in-out delay-150 hover:-translate-y-1 border-2 hover:scale-110 hover:bg-indigo-500 duration-300 inline-block focus-visible:ring ring-indigo-300 text-black border- active:text-gray-700 text-sm md:text-base font-semibold text-center rounded-3xl outline-none px-8 py-3 hover:text-white"
              >Contact</a
            >
          </div>
        </div>
        <!-- content - end -->

        <!-- image - start -->
        <div
          class="xl:w-5/12 h-48 lg:h-auto bg-gray-100 overflow-hidden shadow-lg rounded-lg"
        >
          <img
            src="https://images.unsplash.com/photo-1618004912476-29818d81ae2e?auto=format&q=75&fit=crop&w=1000"
            loading="lazy"
            alt="Photo by Fakurian Design"
            class="w-full h-full object-cover object-center"
          />
        </div>
        <!-- image - end -->
      </section>
    </div>
  </div>
  <!-- hero - end -->
</template>
